import { useState } from 'react';
import { Box, Typography, Divider, Button } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { AssignUserRubric } from '../components/user/assign-juges-rubic';
import { InviteLinkDialog } from '../components/shared/InviteLinkDialog';
import { useAuthContext } from '../context/auth-context';

export const Judge = () => {
  const { activeCamp } = useAuthContext();
  const [inviteOpen, setInviteOpen] = useState(false);

  const inviteUrl = activeCamp
    ? `${window.location.origin}/invite/${activeCamp._id}`
    : '';

  return (
    <div>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#284B32', lineHeight: 1.3 }}>
            Jueces
          </Typography>
          <Button
            variant="outlined"
            size="small"
            startIcon={<LinkIcon />}
            onClick={() => setInviteOpen(true)}
            disabled={!activeCamp}
            sx={{ textTransform: 'none', color: 'text.secondary', borderColor: 'divider' }}
          >
            Invitar juez
          </Button>
        </Box>
        <Divider sx={{ mt: 1.5, borderColor: 'rgba(40,75,50,0.15)' }} />
      </Box>

      <AssignUserRubric handleClose={() => {}} />

      <InviteLinkDialog
        open={inviteOpen}
        onClose={() => setInviteOpen(false)}
        url={inviteUrl}
        title="Invitar juez"
        description="Comparte este link con el juez para que se registre o inicie sesión y se una al campamento."
      />
    </div>
  );
};
